var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome71(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3C2.89543 3 2 3.89543 2 5V19.25C1.58579 19.25 1.25 19.5858 1.25 20C1.25 20.4142 1.58579 20.75 2 20.75H22C22.4142 20.75 22.75 20.4142 22.75 20C22.75 19.5858 22.4142 19.25 22 19.25V10.5588C22 10.2116 21.8198 9.88916 21.5241 9.70717L16.5482 6.64507C15.9054 6.24949 15.0946 6.24949 14.4518 6.64507L9.4759 9.70717C9.18016 9.88916 9 10.2116 9 10.5588V19.25H7.5V10.5588C7.5 9.69067 7.95039 8.88467 8.68976 8.42968L11 7.00799V5C11 3.89543 10.1046 3 9 3H4ZM13 19.25H18V16.5C18 15.1193 16.8807 14 15.5 14C14.1193 14 13 15.1193 13 16.5V19.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome71);
export default __webpack_public_path__ + "static/media/home-7-1.8a6c4ad3be1a9b185d32d4ac5fcdd449.svg";
export { ForwardRef as ReactComponent };